const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPendingRefund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 56,
    viewBox: "0 0 228 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 41.3346H37.3333M18.6667 14.668H37.3333M34.6667 41.3346V35.772C34.6665 35.0648 34.3855 34.3866 33.8853 33.8866L28 28.0013M28 28.0013L22.1147 33.8866C21.6145 34.3866 21.3335 35.0648 21.3333 35.772V41.3346M28 28.0013L22.1147 22.116C21.6145 21.616 21.3335 20.9378 21.3333 20.2306V14.668M28 28.0013L33.8853 22.116C34.3855 21.616 34.6665 20.9378 34.6667 20.2306V14.668",
    stroke: "#CB8600",
    style: {
      stroke: "#CB8600",
      stroke: "color(display-p3 0.7961 0.5255 0.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 27,
    x2: 156,
    y2: 27,
    stroke: "#D7A440",
    style: {
      stroke: "#D7A440",
      stroke: "color(display-p3 0.8431 0.6431 0.2510)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D7A440",
    style: {
      fill: "#D7A440",
      fill: "color(display-p3 0.8444 0.6422 0.2496)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 20L177.333 34.6667L170.667 28M197.333 25.3333L187.333 35.3333L185.333 33.3333",
    stroke: "#CB8600",
    style: {
      stroke: "#CB8600",
      stroke: "color(display-p3 0.7961 0.5255 0.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendingRefund);
export default __webpack_public_path__ + "static/media/icon_pending_refund.7c2e6b2f2778aa7ab242789c192ec0e3.svg";
export { ForwardRef as ReactComponent };